import { render, staticRenderFns } from "./uploaded-invoices.vue?vue&type=template&id=1d908f08&scoped=true"
import script from "./uploaded-invoices.vue?vue&type=script&lang=js"
export * from "./uploaded-invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d908f08",
  null
  
)

export default component.exports